import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum TransactionTypeId {
  PAYMENT_HOTEL_ACCOUNTS = 1,
  CASHBOOK_SUBSIDY = 2,
  CASHBOOK_WITHDRAWAL = 3,
  CASHDESKS_TRANSFER = 4,
  CASHDESKS_EXCHANGE_OFFICE_DEAL = 5,
  CASHDESKS_EXCHANGE_OFFICE_CANCEL = 6,
  CASHDESKS_OTHER = 7,
  CASHDESKS_OPERATION_CASHBOOK = 8,
}

export class TransactionType {
  static readonly PAYMENT_HOTEL_ACCOUNTS = new TransactionType(
    TransactionTypeId.PAYMENT_HOTEL_ACCOUNTS,
    () => $t('Hotel accounts payment'),
    () => $t('Payment'),
  )
  static readonly CASHBOOK_SUBSIDY = new TransactionType(
    TransactionTypeId.CASHBOOK_SUBSIDY,
    () => $t('Cashbook subsidy'),
    () => $t('Subsidy'),
  )
  static readonly CASHBOOK_WITHDRAWAL = new TransactionType(
    TransactionTypeId.CASHBOOK_WITHDRAWAL,
    () => $t('Cashbook withdrawal'),
    () => $t('Withdrawal'),
  )
  static readonly CASHDESKS_TRANSFER = new TransactionType(
    TransactionTypeId.CASHDESKS_TRANSFER,
    () => $t('Transfer between cashbooks'),
    () => $t('Transfer'),
  )
  static readonly CASHDESKS_EXCHANGE_OFFICE_DEAL = new TransactionType(
    TransactionTypeId.CASHDESKS_EXCHANGE_OFFICE_DEAL,
    () => $t('Currency exchange'),
    () => $t('Exchange'),
  )
  static readonly CASHDESKS_EXCHANGE_OFFICE_CANCEL = new TransactionType(
    TransactionTypeId.CASHDESKS_EXCHANGE_OFFICE_CANCEL,
    () => $t('Cancellation of exchange'),
    () => $t('Ex. cancel'),
  )
  static readonly CASHDESKS_OTHER = new TransactionType(
    TransactionTypeId.CASHDESKS_OTHER,
    () => $t('Other payment'),
    () => $t('Other'),
  )
  static readonly CASHDESKS_OPERATION_CASHBOOK = new TransactionType(
    TransactionTypeId.CASHDESKS_OPERATION_CASHBOOK,
    () => $t('Operation cashbook'),
    () => $t('Operation'),
  )

  private constructor(
    public readonly id: TransactionTypeId,
    public readonly name: () => string,
    public readonly shortName: () => string,
  ) {}

  static getById = (id: TransactionTypeId): TransactionType => {
    const value = TransactionType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(TransactionType.name, id)
    }

    return value
  }

  static all = (): TransactionType[] => {
    return [
      TransactionType.CASHBOOK_SUBSIDY,
      TransactionType.PAYMENT_HOTEL_ACCOUNTS,
      TransactionType.CASHBOOK_WITHDRAWAL,
      TransactionType.CASHDESKS_TRANSFER,
      TransactionType.CASHDESKS_EXCHANGE_OFFICE_DEAL,
      TransactionType.CASHDESKS_EXCHANGE_OFFICE_CANCEL,
      TransactionType.CASHDESKS_OTHER,
      TransactionType.CASHDESKS_OPERATION_CASHBOOK,
    ]
  }

  static allForIncome = (): TransactionType[] => {
    return [
      TransactionType.CASHBOOK_SUBSIDY,
      TransactionType.PAYMENT_HOTEL_ACCOUNTS,
      TransactionType.CASHDESKS_TRANSFER,
      TransactionType.CASHDESKS_EXCHANGE_OFFICE_DEAL,
      TransactionType.CASHDESKS_OTHER,
      TransactionType.CASHDESKS_OPERATION_CASHBOOK,
    ]
  }

  static allForExpense = (): TransactionType[] => {
    return [
      TransactionType.CASHBOOK_WITHDRAWAL,
      TransactionType.PAYMENT_HOTEL_ACCOUNTS,
      TransactionType.CASHDESKS_TRANSFER,
      TransactionType.CASHDESKS_EXCHANGE_OFFICE_CANCEL,
      TransactionType.CASHDESKS_OTHER,
      TransactionType.CASHDESKS_OPERATION_CASHBOOK,
    ]
  }
}
